import { cart, checkout, combo, shippingModel } from 'core/use-cases';

/**
 * This list of messages for handling request loading
 *
 */

const addItemMessage = 'Adicionando...';

export const request = {
  [cart.actions.cartFetchForGiftsCheck.request.type]: 'Buscando informações do carrinho...',
  [cart.actions.cartFetch.request.type]: 'Buscando informações do carrinho...',
  [cart.actions.lastCartFetch.request.type]: 'Buscando informações do carrinho...',
  [cart.actions.cartCurrentDeliveryFetch.request.type]: 'Buscando informações do carrinho...',
  [cart.actions.cartSetShippingModelFetch.request.type]: 'Selecionando modelo de entrega...',
  [cart.actions.clearCouponFetch.request.type]: 'Excluindo cupom ou vale-brinde...',
  [cart.actions.itemAddFetch.request.type]: addItemMessage,
  [cart.actions.itemDeleteFetch.request.type]: 'Removendo...',
  [cart.actions.itemUpdateFetch.request.type]: 'Atualizando...',
  [cart.actions.setCouponFetch.request.type]: 'Adicionando cupom ou vale-brinde...',
  [checkout.actions.processFetch.request.type]: 'Calculando seus descontos e brindes...',
  [checkout.actions.promotionFetch.request.type]: 'Carregando as formas de pagamento...',
  [combo.actions.comboPost.request.type]: addItemMessage,
  [shippingModel.actions.currentDeliveryModeFetch.request.type]:
    'Selecionando modelo de entrega...',
};
